// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useMemo } from "react";
import { getBallotStyleSlates, getBallotStyleSlatesCoverage, } from "@sequentech/ui-core";
import { resolveSlates } from "../services/Slates";
var NO_SLATES = { config: null, resolved: null };
/**
 * The slates of a ballot style, read once per ballot style.
 *
 * A ballot style with an invalid slate configuration is refused when it is
 * loaded, so one that fails here is treated as having no slates.
 */
export var useBallotStyleSlates = function (ballotStyle) {
    return useMemo(function () {
        if (!ballotStyle) {
            return NO_SLATES;
        }
        try {
            var config = getBallotStyleSlates(ballotStyle.ballot_eml);
            if (!config) {
                return NO_SLATES;
            }
            var coverage = getBallotStyleSlatesCoverage(ballotStyle.ballot_eml);
            return {
                config: config,
                resolved: resolveSlates(config, ballotStyle.ballot_eml.contests, coverage),
            };
        }
        catch (_a) {
            return NO_SLATES;
        }
    }, [ballotStyle]);
};
